
"use client"

import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-[26px] w-[48px] shrink-0 cursor-pointer items-center rounded-full",
      // Transição premium com easing Apple-like
      "transition-all duration-200 ease-[cubic-bezier(0.16,1,0.3,1)]",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      "disabled:cursor-not-allowed disabled:opacity-50 relative overflow-hidden",
      // Estado OFF - Fundo cinza
      "bg-[#D4D9E1]",
      // Estado ON - Fundo azul Host + glow sutil
      "data-[state=checked]:bg-[#1F6BFF]",
      "data-[state=checked]:shadow-[0_0_0_3px_rgba(31,107,255,0.12)]",
      // Borda transparente
      "border border-transparent",
      // Hover suave
      "hover:opacity-90",
      className
    )}
    {...props}
    ref={ref}
  >
    {/* Stripe animado - apenas quando ON */}
    <div 
      className={cn(
        "absolute inset-0 pointer-events-none transition-opacity duration-300",
        // Visível apenas quando checked
        "opacity-0 data-[state=checked]:opacity-100"
      )}
      data-state={props.checked ? "checked" : "unchecked"}
      style={{
        background: 'linear-gradient(90deg, transparent 0%, transparent 25%, rgba(255,255,255,0.3) 50%, transparent 75%, transparent 100%)',
        backgroundSize: '200% 100%',
        animation: 'slideStripe 1.8s linear infinite'
      }}
    />

    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-[22px] w-[22px] rounded-full",
        // Transição premium com easing Apple-like
        "transition-all duration-200 ease-[cubic-bezier(0.16,1,0.3,1)]",
        // Sempre branco (tanto OFF quanto ON)
        "bg-white",
        // Sombras diferentes por estado
        "shadow-[0_1px_3px_rgba(0,0,0,0.15)]",
        "data-[state=checked]:shadow-[0_2px_8px_rgba(0,0,0,0.2)]",
        // Movimento da bolinha
        "data-[state=checked]:translate-x-[22px] data-[state=unchecked]:translate-x-[2px]",
        // Micro-scale ao ativar
        "data-[state=checked]:scale-[1.03]"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
